import React, { useEffect, useState } from 'react'
import {
  List,
  Datagrid,
  TextField,
  TextInput,
  useTranslate,
  useResourceContext,
  useResourceDefinitions,
  useListController,
  useStore,
  BooleanField
} from 'react-admin'
import { Container } from '@mui/material'
import { CardCommon } from 'src/components/uiElements'
import { ListViewActionsButtons } from 'src/components/uiElements/buttons/ListViewActionsButtons'
import { ListViewTopToolbar } from 'src/components/uiElements/CRUD/ListViewTopToolbar'
import { PostFilterButtonCommerceNumber, PostFilterFormCommerceNumber } from './CommerceNumberFilter'

export function CommerceNumberList(props) {
  const translate = useTranslate()
  const { setSort, isFetching } = useListController()
  const [isSorting, setIsSorting] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [permissionsStore, setPermissionsStore] = useStore('currentResource', '{}')
  const [permissions, setPermissions] = useState(null)
  const propsResource = useResourceDefinitions()
  const resourceName = useResourceContext()

  useEffect(() => {
    setPermissionsStore(JSON.stringify(propsResource[resourceName]))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [propsResource, resourceName])

  useEffect(() => {
    if (permissionsStore) {
      setPermissions(JSON.parse(permissionsStore))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [permissionsStore])

  useEffect(() => {
    if (isSorting && isFetching) {
      setIsLoading(true)
    } else if (isLoading && isSorting && !isFetching) {
      setIsLoading(false)
      setIsSorting(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSorting, isFetching])

  const onClickSort = (sort) => {
    setSort(sort)
    setIsSorting(true)
  }

  const hasPermissions = () => {
    return permissions?.options?.revision ||
      permissions?.hasShow ||
      permissions?.hasEdit ||
      permissions?.options?.delete
  }


  const commerceNumberFilters = [
    { source: 'value', name: 'ra.field.commerce_number' },
    { source: 'terminal', name: 'ra.field.terminal' },
    { source: 'company_id', name: 'ra.field.company' },
    { source: 'card_id', name: 'ra.field.card' },
    { source: 'gateway_id', name: 'ra.field.gateway' },
    { source: 'work_unit_id__in', name: 'ra.field.work_unit' },
  ]

  return (
    <Container className='content'>
      <CardCommon title={translate('ra.entity.commerce-number')}>
        <List
          {...props}
          component='div'
          actions={
            <ListViewTopToolbar
              hasCreate={permissions?.hasCreate}
              FilterButtonComponent={PostFilterButtonCommerceNumber}
              FilterFormComponent={PostFilterFormCommerceNumber}
              listFilters={commerceNumberFilters}
            />
          }
        >
          <Datagrid setSort={onClickSort} isLoading={isLoading}>
            <TextField source='id' label={translate('ra.field.id')} />
            <TextField source='value' label={translate('ra.field.commerce_number')} sortable={false} />
            <TextField source='terminal' label={translate('ra.field.terminal')} sortable={false} />
            <TextField
              source='gateway_relation.name'
              label={translate('ra.field.gateway')}
              sortable={false}
            />
            <TextField
              source='work_unit.long_name'
              label={translate('ra.field.work_unit')}
              sortable={false}
            />
            <TextField
              source='company_relation.long_name'
              label={translate('ra.field.company')}
              sortable={false}
            />
            <TextField source='card_relation.long_name' label={translate('ra.field.card')} sortable={false} />
            <BooleanField source='is_active' label={translate('ra.field.is_active')} sortable={false} />
            {hasPermissions() && (
              <ListViewActionsButtons
                label={translate('ra.action.actions')}
                fieldsName={['short_name']}
                genderElement='masculine'
              />
            )}
          </Datagrid>
        </List>
      </CardCommon>
    </Container>
  )
}
